var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelCalendarSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M8 10H4v2H3v-2H0V9h3V7H0V6h3V4H0V3h12v1H9v2h3v1H9v2h3v1H9v2H8zm0-1H4V7h4zm0-3H4V4h4zM0 2.009A2.01 2.01 0 0 1 2.009 0H9.99A2.01 2.01 0 0 1 12 2.009V9.99A2.01 2.01 0 0 1 9.991 12H2.01A2.01 2.01 0 0 1 0 9.991z"
})));
export default SvgChannelCalendarSm;